export default __webpack_public_path__ + "static/media/OSM-slider1.b0e2c264.jpg";